import gql from 'graphql-tag';
import Product from '../../../entity/product';

const getProduct = gql`
  query productByStore(
    $id: IDString
    $manageId: String
  ) {
    productByStore(
      id: $id
      manageId: $manageId
    ) {
      ${Product.fragmentsFields()}
    }
  }
`;

export default getProduct;
